import React, { useEffect, useState } from "react";
import { AddUsersWrapper } from "./styled";
import Breadcrumbs from "../../../components/admin/Breadcrumbs/Breadcrumbs";
import {
  BackButton,
  Box,
  ButtonStyled,
  TabsList,
} from "../../../components/styled/Elements";
import { tempUserFormTabs } from "../../../helpers/adminConstants/AdminConstants";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ContentWrapper } from "../../../components/styled/styled";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import UsersApi from "../../../services/api/usersApi";
import { toast } from "react-toastify";
import { PlaceholderImg } from "../../../components/styled/AllImages";

const EditTemporaryUser = () => {
  const navigate = useNavigate();
  const assetURL = process.env.REACT_APP_ASSET_URL;
  const { id } = useParams();
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const {
    reset,
    register,
    control,
    handleSubmit,
    trigger,
    watch,
    resetField,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });

  const [activeTab, setActiveTab] = useState(tempUserFormTabs[0]);
  const [previewImg, setPreviewImg] = useState(null);
  const [secondPreviewImg, setSecondPreviewImg] = useState(null);
  const [loading, setLoading] = useState(false);
  const [permissions, setPermissions] = useState({});
  const [userSections, setUserSections] = useState([0]);
  const currentTabIndex = tempUserFormTabs.findIndex(
    (tab) => tab.id === activeTab.id
  );
  const [userDetails, setUserDetails] = useState({});
//   const [dataLoading, setDataLoading] = useState(false);
  const [sharedCabinets, setSharedCabinets] = useState([]);
  const handleTabChange = async (tabIndex) => {
    const fieldsToValidate = userSections.flatMap((index) => [
      `users[${index}].name`,
      `users[${index}].email`,
      `users[${index}].phone`,
    ]);

    const isValid = await trigger(fieldsToValidate, { shouldFocus: true });
    if (isValid) {
      setActiveTab(tempUserFormTabs[tabIndex]);
    }
  };

  const handleNext = async () => {
    const fieldsToValidate = userSections.flatMap((index) => [
      `users[${index}].name`,
      `users[${index}].email`,
      `users[${index}].phone`,
    ]);

    const isValid = await trigger(fieldsToValidate, { shouldFocus: true });
    if (isValid) {
      setActiveTab(tempUserFormTabs[currentTabIndex + 1]);
    }
  };

  const addAnotherUser = () => {
    setUserSections((prev) => [...prev, prev.length]);
  };

  const getTempSingleUser = async () => {
    try {
    //   setDataLoading(true);
      const { data, code } = await UsersApi.getTempSingleUser(id);
      if (code === 200) {
        const profileImg = data?.profile
          ? `${assetURL}/${data?.profile}`
          : PlaceholderImg;

        reset({
          user_id: data?.id,
          "users[0].profile": profileImg,
          status: parseInt(data?.status),
          "users[0].name": data?.name || "",
          id_number: data?.user_detail?.id_number || "",
          "users[0].email": data?.email || "",
          "users[0].phone": data?.phone || "",
        });

        const mappedPermissions = {};

        data?.shared_cabinets?.forEach(({ cabinet_id, operation_id }) => {
          if (!mappedPermissions[cabinet_id]) {
            mappedPermissions[cabinet_id] = new Set();
          }
          mappedPermissions[cabinet_id].add(operation_id);
        });

        const finalPermissions = {};
        Object.keys(mappedPermissions).forEach((cabinetId) => {
          finalPermissions[cabinetId.toString()] = Array.from(
            mappedPermissions[cabinetId]
          );
        });

        setPermissions(finalPermissions);
      }
    } catch (error) {
    } finally {
    //   setDataLoading(false);
    }
  };

  const getSharedCabinets = async () => {
    try {
      const { code, data } = await UsersApi.getSharedCabinets();
      if (code === 200) {
        const updatedData = data?.data?.map((cabinet) => ({
          id: cabinet?.id,
          module_name: cabinet?.name,
          view: 1,
          view_open: 2,
        }));
        setSharedCabinets(updatedData);
      }
    } catch (err) {
      console.error("Failed to fetch shared cabinets", err);
    }
  };
  

  useEffect(() => {
    getTempSingleUser();
    getSharedCabinets()
  }, []);

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const formData = new FormData();

      userSections?.forEach((sectIndex) => {
        const user = data?.users?.[sectIndex];

        formData.append(`users[${sectIndex}][action]`, "update");
        formData.append(`users[${sectIndex}][name]`, user?.name);
        formData.append(`users[${sectIndex}][email]`, user?.email);
        formData.append(`users[${sectIndex}][phone]`, user?.phone);
        formData.append(`users[${sectIndex}][user_id]`, id);
        // formData.append(`users[${sectIndex}][profile]`, user?.profile);

        formData.append(`profile[${sectIndex}]`, user?.profile);
      });

      formData.append("cabinet_shared", JSON.stringify(permissions));

      const { code, message, error } = await UsersApi.createTemporaryUser(
        formData
      );

      if (code === 200) {
        toast.success(t("user_updated"));
        navigate("/temporary-users");
      } else if (code === 204 || code === 100) {
        toast.error(message);
      } else if (code === 500 && error) {
        toast.error(error);
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.message);
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <AddUsersWrapper>
      <Box className="content-head">
        <Box className="d-flex align-items-center flex-wrap flex-sm-nowrap gap-3 gap-md-5">
          <BackButton
            label={t("edit_temporary_user")}
            onClick={() => navigate("/temporary-users")}
          />
          <Breadcrumbs />
        </Box>
      </Box>

      <Box>
        <TabsList
          tabs={tempUserFormTabs}
          activeTab={activeTab}
          handleTabChange={handleTabChange}
        />
      </Box>
      <ContentWrapper>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <activeTab.component
            register={register}
            control={control}
            errors={errors}
            watch={watch}
            resetField={resetField}
            setValue={setValue}
            previewImg={previewImg}
            setPreviewImg={setPreviewImg}
            secondPreviewImg={secondPreviewImg}
            setSecondPreviewImg={setSecondPreviewImg}
            permissions={permissions}
            setPermissions={setPermissions}
            userSections={userSections}
            sharedCabinets={sharedCabinets}
            userDetails={userDetails}
          />
          <Box className="d-flex justify-content-between mx-3 mx-lg-5 py-4">
            <ButtonStyled
              label={t("back")}
              bg="var(--themeColor2)"
              type="button"
              onClick={() => setActiveTab(tempUserFormTabs[0])}
              disabled={activeTab === tempUserFormTabs[0]}
            />
            {activeTab === tempUserFormTabs[0] && (
              <ButtonStyled
                label={t("next")}
                type="button"
                bg="var(--themeColor2)"
                onClick={handleNext}
              />
            )}

            {activeTab === tempUserFormTabs[1] && (
              <ButtonStyled
                type="submit"
                label={t("save_create")}
                isLoading={loading}
                // disabled={Object.keys(permissions).length === 0}
              />
            )}
          </Box>
        </Form>
      </ContentWrapper>
    </AddUsersWrapper>
  );
};

export default EditTemporaryUser;
